import { connect } from "react-redux";
import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { resetModalError } from "../../redux/cart/action";

const ModalCartErrorComponent = ({ modalCartError, resetModalError }) => {
  const defaultErrorMessage =
    "Ops! Sembra che questo carrello sia stato precedentemente svuotato. Ti invitiamo a riprovare!";

  return (
    <Modal
      centered
      isOpen={modalCartError}
      backdrop="static"
      keyboard={false}
      toggle={resetModalError}
    >
      <ModalHeader toggle={resetModalError}>Carrello vuoto!</ModalHeader>
      <ModalBody>{defaultErrorMessage}</ModalBody>
      <ModalFooter>
        <Button onClick={resetModalError} variant="secondary">
          Ho Capito!
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    modalCartError: state.cartReducer.modalCartError,
  };
};

export default connect(mapStateToProps, { resetModalError })(
  ModalCartErrorComponent
);
